import { FONT, RADIUS } from "@/styles/common";
import { Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const Wrapper = styled(Flex)`
    position: relative;
    width: 768px;
    height: 640px;
    flex-direction: column;
    text-align: center;
    ${RADIUS(4)}
    row-gap: 16px;
    padding: 24px;
    box-sizing: border-box;
    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        max-width: 640px;
        width: 90vw;
        height: 50vh;
        padding: 16px;
    }

    & > div > textarea {
        height: 100%;
        background-color: white;
        border: none !important;
        padding: 0 !important;
        line-height: 1.5 !important;
    }
`;

export const CustomText = styled(Text)`
    ${FONT("pretendard", 16, 500)};
`;
